import React from 'react';
import './RoleBadge.css';

const RoleBadge = ({ role, size = 'medium' }) => {
  const roleConfig = {
    admin: {
      icon: '👨‍💼',
      label: 'Admin',
      className: 'role-admin'
    },
    central_help_desk: {
      icon: '📞',
      label: 'Help Desk',
      className: 'role-central_help_desk'
    },
    manager: {
      icon: '👨‍⚕️',
      label: 'Manager',
      className: 'role-manager'
    },
    technician: {
      icon: '🔧',
      label: 'Technician',
      className: 'role-technician'
    },
    coordinator: {
      icon: '📋',
      label: 'Coordinator',
      className: 'role-coordinator'
    },
    custodian: {
      icon: '🔐',
      label: 'Custodian',
      className: 'role-custodian'
    },
    superadmin: {
      icon: '👑',
      label: 'Super Admin',
      className: 'role-superadmin'
    }
  };

  // If role is not found, show "not defined" instead of defaulting to a role
  const config = roleConfig[role] || {
    icon: '❓',
    label: 'Not Defined',
    className: 'role-undefined'
  };

  return (
    <span className={`role-badge role-badge-${size} ${config.className}`}>
      <span className="role-icon">{config.icon}</span>
      <span className="role-label">{config.label}</span>
    </span>
  );
};

export default RoleBadge;
